import { render, staticRenderFns } from "./render3.vue?vue&type=template&id=33524a82"
import script from "./render3.vue?vue&type=script&lang=js"
export * from "./render3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports